import { useTranslation } from 'next-i18next'

import styles from '../collection-title/collection-title.module.scss'

export interface ItemCountLegacyProps {
  totalItems: number
}

export const ItemCountLegacy = ({ totalItems }: ItemCountLegacyProps) => {
  const { t } = useTranslation('common')

  return (
    <div className={styles.item_count}>
      {t(totalItems === 1 ? 'totalitems_item' : 'totalitems_items', { totalItems })}
    </div>
  )
}
